export const PATHS = {
  403: {
    Path: "/403",
  },
  AppConfig: {
    Path: "/udo-config",
    Tabs: {
      DeploymentTypes: {
        Path: "deployment-types",
      },
      ModuleUsage: {
        Path: "module-usage",
      },
      CustomComponents: {
        Path: "custom-components",
      },
      DefaultCustomerInsightsConfig: {
        Path: "customer-insights-config",
      },
    },
  },
  Customers: {
    Path: "/customers",
    Pages: {
      Customer: {
        Path: ":customerId",
        Tabs: {
          CustomerGeneralInfoTab: {
            Path: "overview",
          },
          CustomerUsersTab: {
            Path: "customer-users",
          },
          Agents: {
            Path: "agent-settings",
          },
          RestApiToken: {
            Path: "rest-api-token",
          },
          CustomerInsightsConfigTab: {
            Path: "customer-insights-config",
          },
          CustomerWidgetsTab: {
            Path: "widgets",
          },
          PersonasPromptsTab: {
            Path: "personas-prompts",
          },
        },
      },
    },
  },
  Data: {
    Path: "/data",
    Tabs: {
      Export: {
        Path: "export",
      },
      Interfon: {
        Path: "interfon",
      },
      CustomerApi: {
        Path: "customer-api",
      },
    },
  },
  Dashboard: {
    Path: "/dashboard",
  },
  Manual: {
    Path: "/manual",
  },
  MailAmbition: {
    Path: "/mailambition",
    Tabs: {
      Templates: {
        Path: "templates",
      },
      Reporting: {
        Path: "reporting",
      },
    },
  },
  Widgets: {
    Path: "/widgets",
  },
  Settings: {
    Path: "/settings",
  },
  Agents: {
    Path: "/agents",
    Prompts: {
      Path: "/agents/prompts-details",
      Details: {
        Path: ":promptId",
        Tabs: {
          path: ":promptType",
        },
      },
    },
    Tabs: {
      Personas: {
        Path: "personas-prompts",
      },
      TokenPricing: {
        Path: "token-pricing",
      },
      Reporting: {
        Path: "reporting",
      },
    },
  },
  Users: {
    Path: "/users",
    Page: {
      User: {
        Path: ":userId",
        Tabs: {
          OverviewTab: {
            Path: "overview",
          },
          CompaniesTab: {
            Path: "companies",
          },
        },
      },
    },
  },
};
